import flowSave from './config/flow-save';
import flowComplete from './config/flow-complete';
import flowReject from './config/flow-reject';

import flowTransmit from './config/flow-transmit';
import flowPlanned from './config/flow-planned';
import flowWorktrack from './config/flow-worktrack';
import flowWorktrackLi from './config/flow-worktrackli';
import flowWorktrackTree from './config/flow-worktracktree';

import flowReaded from './config/flow-readed';
import flowTovoid from './config/flow-tovoid';

import flowVirtuallog from './config/flow-virtuallog';
import flowSendleader from './config/flow-sendleader';
import flowSendsecretary from './config/flow-sendsecretary';
import flowSecrecord from './config/flow-secrecord';

import flowSpsendleader from './config/flow-spsendleader';
import flowSpsecrecord from './config/flow-spsecrecord';
import showTransactionDialog from './config/flow-transaction-dialog';
import showFlowImage from './config/flow-show-flow-image';


import formSave from './config/form-save';
import formClose from './config/form-close';


function addActions (callback) {
  //PF.action没有就报错
  if (!PF.action) PF.action = {};
  if (!PF.action.flowsave) {
    let actions = {
      flowsave: flowSave,
      flowcomplete: flowComplete,
      flowreject: flowReject,
      flowtransmit: flowTransmit,
      flowplanned: flowPlanned,
      flowworktrack: flowWorktrack,
      flowworktrackli: flowWorktrackLi,
      flowworktracktree: flowWorktrackTree,
      flowreaded: flowReaded,
      flowtovoid: flowTovoid,
      flowvirtuallog: flowVirtuallog,
      flowsendleader: flowSendleader,
      flowsendsecretary: flowSendsecretary,
      flowsecrecord: flowSecrecord,
      flowspsendleader: flowSpsendleader,
      flowspsecrecord: flowSpsecrecord,
      showTransactionDialog,
      showFlowImage,
      formSave,

      formSaveAndClose: function ($form,noMsg) {
        return formSave.call(this, $form, true,noMsg)
      },
      formClose: formClose,
      formEdit: function ($form) {
        if($form.__originalExtForm && $form.__originalExtForm.setEditMode){
          $form.__originalExtForm.setEditMode(true);
        }else{
          $form.setTextMode(false)
        }
      }
    };

    Object.assign(PF.action, actions);
  }
}
addActions();
export default addActions;



// WEBPACK FOOTER //
// ./src/common/components/extend/form/src/action.js